/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-item/report-new-product-section-item/report-new-product-section-item.component.scss */
/*# sourceMappingURL=report-new-product-section-item.component.css.map */
